// @ts-nocheck
import React from 'react';
import { ChevronDown as _lr_ChevronDown } from 'lucide-react';
import { cn } from '../../lib/utils';

const ChevronDown = _lr_ChevronDown || (() => null);
/** @param {{ label?: any, options?: Array<any>, value?: any, onChange?: any, placeholder?: string, error?: any, className?: string }} props */
export default function Select({ label, options = [], value, onChange, placeholder = 'Select...', error, className = '' }) {
  const normalizedOptions = Array.isArray(options)
    ? options.reduce((list, opt) => {
        if (typeof opt === 'string') {
          list.push({ key: opt, value: opt, label: opt });
          return list;
        }

        if (opt && typeof opt === 'object') {
          const optionValue = typeof opt.value === 'string' || typeof opt.value === 'number'
            ? String(opt.value)
            : '';
          if (!optionValue) {
            return list;
          }

          const optionLabel = typeof opt.label === 'string' || typeof opt.label === 'number'
            ? String(opt.label)
            : optionValue;
          list.push({ key: optionValue, value: optionValue, label: optionLabel });
        }

        return list;
      }, [])
    : [];

  return (
    <div className="space-y-1.5">
      {label && (
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">{label}</label>
      )}
      <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={cn(
            'w-full appearance-none px-4 py-2.5 pr-10 bg-white dark:bg-gray-900 border rounded-lg text-sm',
            'text-gray-900 dark:text-gray-100',
            'transition-all duration-200 focus:outline-none',
            error
              ? 'border-red-300 focus:ring-2 focus:ring-red-500/20 focus:border-red-500'
              : 'border-gray-200 dark:border-gray-700 focus:ring-2 focus:ring-[hsl(var(--ring)_/_0.2)] focus:border-[hsl(var(--primary))]',
            className
          )}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {normalizedOptions.map((opt) => (
            <option key={opt.key} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <ChevronDown size={16} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" />
      </div>
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  );
}
